var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('b-form-input-date-between',{class:[{ error: _vm.errors.first('buscaAvancada.periodo') }],attrs:{"start":{
            name: _vm.campo_1,
            value: _vm.filtro[_vm.campo_1]
        },"end":{
            name: _vm.campo_2,
            value: _vm.filtro[_vm.campo_2]
        },"disabled":_vm.desabilitado,"required":_vm.required,"scope":"filtro"},on:{"start":function($event){return _vm.atualizaDataInicio($event)},"end":function($event){return _vm.atualizaDataFim($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }